import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class VisitorsInvitesGroupsIndexController extends Controller {
  queryParams = ['startDate', 'endDate', 'page', 'query', { selectedFlows: { as: 'visitor_types' } }];

  @tracked startDate: string | null = null;
  @tracked endDate: string | null = null;
  @tracked page = 1;
  @tracked query = '';
  @tracked selectedFlows = '';
}
